export default {
  dataEditStaff({ commit }, data) {
    commit("SET_DATA_EDITS_STAFF", data);
  },

  clear({ commit }) {
    commit("CLEAR_DATA");
  }
};
